import {lazy} from 'react';

export const SpecialistFindFriendsAsync = lazy(() =>
    import('./SpecialistFindFriends')
);
